module.exports = __webpack_public_path__ + "5fb21f39.svg";